'use client';

import { useState } from 'react';
import {
    TextInput,
    Popover,
    ColorPicker,
    ActionIcon,
    Stack,
    Group,
} from '@mantine/core';
import { IconPalette } from '@tabler/icons-react';

type Props = {
    label: string;
    value: string;
    onChange: (value: string) => void;
};

function normalizeColor(value: string) {
    if (!value) return '#ff0000';

    if (/^#([0-9A-F]{3}){1,2}$/i.test(value)) return value;

    const namedColors: Record<string, string> = {
        red: '#ff0000',
        blue: '#0000ff',
        green: '#008000',
        black: '#000000',
        white: '#ffffff',
        yellow: '#ffff00',
        gray: '#808080',
        grey: '#808080',
        orange: '#ffa500',
        purple: '#800080',
        pink: '#ffc0cb',
    };

    return namedColors[value.toLowerCase()] || '#ff0000';
}

export function ColorField({ label, value, onChange }: Props) {
    const [opened, setOpened] = useState(false);

    const safeValue = normalizeColor(value);

    console.log('[ColorField] render', { label, value, safeValue, opened });

    return (
        <Stack gap={6} style={{ flex: 1 }}>
            <label style={{ fontSize: 14, fontWeight: 500 }}>{label}</label>

            <Group gap="xs" wrap="nowrap" align="end">
                <TextInput
                    style={{ flex: 1 }}
                    value={value}
                    onChange={(e) => {
                        console.log('[ColorField] input change', e.currentTarget.value);
                        onChange(e.currentTarget.value);
                    }}
                />

                <Popover
                    opened={opened}
                    onChange={(next) => {
                        console.log('[ColorField] popover onChange', next);
                        setOpened(next);
                    }}
                    position="bottom-end"
                    withArrow
                    shadow="md"
                    withinPortal
                    zIndex={10000}
                >
                    <Popover.Target>
                        <ActionIcon
                            variant="light"
                            size="lg"
                            aria-label={`Choisir ${label}`}
                            onClick={() => {
                                console.log('[ColorField] palette click');
                                setOpened((prev) => {
                                    const next = !prev;
                                    console.log('[ColorField] toggle opened', { prev, next });
                                    return next;
                                });
                            }}
                        >
                            <IconPalette size={16} />
                        </ActionIcon>
                    </Popover.Target>

                    <Popover.Dropdown
                        style={{
                            background: '#fff',
                            border: '1px solid #ddd',
                            padding: 12,
                            minWidth: 240,
                            zIndex: 10000,
                        }}
                    >
                        <Stack gap="sm">
                            <div style={{ fontSize: 12 }}>Couleur actuelle : {safeValue}</div>

                            <ColorPicker
                                format="hex"
                                value={safeValue}
                                onChange={(nextColor) => {
                                    console.log('[ColorField] picker change', nextColor);
                                    onChange(nextColor);
                                }}
                            />
                        </Stack>
                    </Popover.Dropdown>
                </Popover>
            </Group>
        </Stack>
    );
}